module.exports = __webpack_public_path__ + "static/media/github-icon.f49508ce.svg";